/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type importSageIntacctExpenseItemModal_viewer = {
    readonly id: string;
    readonly actualPersonId: string | null;
    readonly " $refType": "importSageIntacctExpenseItemModal_viewer";
};
export type importSageIntacctExpenseItemModal_viewer$data = importSageIntacctExpenseItemModal_viewer;
export type importSageIntacctExpenseItemModal_viewer$key = {
    readonly " $data"?: importSageIntacctExpenseItemModal_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"importSageIntacctExpenseItemModal_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "importSageIntacctExpenseItemModal_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = '2c006bbf80244123db7e251250f259a1';
export default node;
